export const CONTENT_BASE_SEGMENT = {
  HOME: '홈',
  FAVORITE: '즐겨찾기',
  NOTICE: '공지',
} as const;

export const CONST_CONTENT_CATEGORY = {
  HOME: '홈',
  FAVORITE: '즐겨찾기',
} as const;

export const POPULAR_CONTENT_SEGMENT = {
  POPULAR: '인기글',
} as const;
